import { Modal } from "@app/shared/Modals";
import { FC } from "react";

interface DeleteJobQueueModalProps {
  id: number;
  queueName: string;
  confirmDelete: () => void;
  closeModal: () => void;
  isVisible: boolean;
}

export const DeleteJobQueueModal: FC<DeleteJobQueueModalProps> = (props: DeleteJobQueueModalProps) => {
    return (
        <Modal
            isVisible={props.isVisible}
            closeModal={props.closeModal}
            content={{
                body: `Are you sure you want to delete the job queue ${props.queueName}?`,
                cancelButtonText: "Cancel",
                confirmButtonAction: props.confirmDelete,
                confirmButtonText: "Confirm",
                title: "Warning",
            }}
            hideBodyScroll={true}
        />)
}

export default DeleteJobQueueModal;